<template>
  <l-default>

    <OTitle>Free Credits</OTitle>

    <div>
      <CShareThisFollow/>

      <h2 class="c_free_credits">EMAIL</h2>

      IMPORTANT: Make sure you can receive emails from <em>info@myphonerobot.com</em>. Check your <em>spam folder</em>,
      check your <em>promotions folder</em> and <em>mark</em> our emails as <em>important</em> so you can receive them
      freely. Instruct your email client to <em>whitelist info@myphonerobot.com</em>. We send emails with promo codes
      with free credits and discounts on a weekly basis. Free credits promo codes will just add some free credits to
      your balance for free, those are usually <em>valid for 2 days</em> since email is received. Discount promo codes
      will add more credits with every purchase, those are much more effective and they are usually <em>valid for 2 days</em>
      since email is received. You can unsubscribe at any time via the link at the bottom of every email.

      <h2 class="c_free_credits">Social Follow</h2>

      We send promo codes for <em>free credits</em> and <em>discounts</em> via posting on our social profiles. If you
      want to receive
      those and other important news, please follow us:<br/>
      <br/>
      <CAdLinkdial/>

      <h2 class="c_free_credits">More</h2>

      We are cooking other methods of earning credits, including but not limited to an affiliate program, browser push
      notifications, and SMS promo codes. Please, check this page regularly for all benefits.
    </div>
  </l-default>
</template>

<script>
import LDefault from '../../layouts/LDefault'
import OTitle from '../../objects/OTitle'
import CShareThisFollow from '../../components/CShareThisFollow'
import CAdLinkdial from '../../components/CAdLinkdial'

export default {
  name: 'PageFreeCredits',
  components: { OTitle, LDefault, CShareThisFollow, CAdLinkdial },
  metaInfo: {
    title: 'Spoof Call And Caller ID Faker | Free Credits',
    meta: [
      {
        name: 'description',
        content: 'Spoof Call And Caller ID Faker - Free Credits'
      },
      {
        name: 'keywords',
        content: 'myphonerobot free credits'
      }
    ]
  }
}
</script>

<style lang="scss">

.c_free_credits {
  color: $primary;
}

</style>
